import DataContainer from '../../../logic/dataContainer';

export const CLINIC_LIST_FIELDS = [
  'TherapyProcedures',
  'DisordersMainFocus',
  'DisordersExclusion',
  'Treatments',
];

export const CLINIC_LIST_BOOL_FIELDS = [
  'ClinicEligble',
  'LegallyInsuredPatientsTreated',
  'AccompanyingPartner',
  'AccompanyingChildren',
  'AccompanyingPets',
];

export const TYPE_OF_CLINIC_OPTIONS = [
  { value: 'acute', label: 'Akut' },
  { value: 'reha', label: 'Reha' },
  { value: 'mixed', label: 'Akut & Reha' },
];

export const TREATMENT_SETTING_OPTIONS = [
  { value: 'inpatient', label: 'vollstationär' },
  { value: 'daycare', label: 'teilstationär' },
  { value: 'both', label: 'voll- und teilstationär' },
];

export const FIRST_CONTACT_BY_OPTIONS = [
  { value: 'care', label: 'CARE-Beratung' },
  { value: 'client', label: 'Klientin / Klient' },
  { value: 'none', label: 'keine Vorgabe' },
];

export const YES_NO_OPTIONS = [
  { value: 'true', label: 'Ja' },
  { value: 'false', label: 'Nein' },
];

export const ACCOMPANYING_OPTIONS = [
  { value: 'AccompanyingPartner', label: 'Partner/in' },
  { value: 'AccompanyingChildren', label: 'Kinder' },
  { value: 'AccompanyingPets', label: 'Haustiere' },
];

export const labelOf = (options, value) => {
  const option = options.find((element) => element.value === value);
  return option ? option.label : '';
};

// Die Middleware liefert Listen als JSON-Array-String und "" fuer
// "keine Angabe"; DataContainer hat sie ggf. schon geparst.
export const parseList = (value) => {
  if (Array.isArray(value)) return value;
  if (typeof value !== 'string' || value === '') return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    console.warn(
      'Klinik: Liste ist kein gültiges JSON, wird als leer behandelt.',
      value,
    );
    return [];
  }
};

export const isTrue = (value) => value === true || value === 'true';

// null = "keine Angabe", damit ein Nein-Filter Bestandsdaten nicht trifft.
const parseOptionalBool = (value) => {
  if (value === true || value === 'true') return true;
  if (value === false || value === 'false') return false;
  return null;
};

export const normalizeClinicRow = (row) => {
  const normalized = { ...row };
  CLINIC_LIST_FIELDS.forEach((key) => {
    normalized[key] = parseList(row[key]);
  });
  CLINIC_LIST_BOOL_FIELDS.forEach((key) => {
    normalized[key] = parseOptionalBool(row[key]);
  });
  return normalized;
};

export const newClinicDataContainer = () => {
  const dataContainer = new DataContainer();
  dataContainer.add('ClinicData', {
    ClinicName: '',
    Street: '',
    ZIP: '',
    City: '',
    Lat: '',
    Lon: '',
    ZipLat: '',
    ZipLon: '',
    Landline: '',
    Handy: '',
    Fax: '',
    Mail: '',
    Website: '',
    Management: '',
    MedicalAdministration: '',
    CooperationContactName: '',
    CooperationContactPhone: '',
    CooperationContactMail: '',
    CooperationAgreement: '',
    ContactInformation: '',
    MailToCare: '',
    MailToPatient: '',
    TypeOfClinic: '',
    TreatmentSetting: '',
    TherapyProcedures: [],
    TherapeuticOrientation: '',
    DisordersMainFocus: [],
    DisordersExclusion: [],
    TreatmentFocus: '',
    Treatments: [],
    SpecialTreatmentConcepts: '',
    SpecialFeaturesOfTheClinic: '',
    AccompanyingPartner: false,
    AccompanyingChildren: false,
    AccompanyingPets: false,
    AccompanyingNotes: '',
    Unlocked: false,
  });
  dataContainer.add('PrivateInsured', {
    ClinicEligble: false,
    DailyRate: '',
    SingleBedRoom: false,
    ChiefPhysicianTreatment: false,
    OtherOptionalServices: '',
    ShorterWaitingTimesDueToCare: '',
    AverageWaitingTimesAtTheClinic: '',
    PrivateAverageLengthOfStayReha: '',
    PrivateAverageLengthOfStayAcute: '',
    PrivateAftercare: false,
  });
  dataContainer.add('LegallyInsured', {
    LegallyInsuredPatientsTreated: false,
    LegallyAverageWaitingTimesAtTheClinic: '',
    LegallyAverageLengthOfStayReha: '',
    LegallyAverageLengthOfStayAcute: '',
    LegallyAftercare: false,
  });
  dataContainer.add('Procedure', {
    FirstContactBy: '',
    CareContactName: '',
    CareContactPhone: '',
    PrivateContactName: '',
    PrivateContactPhone: '',
    PrivateContactMail: '',
    LegallyContactName: '',
    LegallyContactPhone: '',
    LegallyContactMail: '',
    ApplicationSupportPrivate: false,
    ApplicationSupportPrivateDescription: '',
    ApplicationSupportLegally: false,
    ApplicationSupportLegallyDescription: '',
    ProcedureApplication: '',
    SpecialistStatementPossible: false,
    PreliminaryTalkPossible: false,
    TrialDayPossible: false,
  });
  return dataContainer;
};

// Bestandskliniken liefern "" fuer Listen; die Mehrfachauswahl braucht Arrays.
export const normalizeClinicContainer = (dataContainer) => {
  CLINIC_LIST_FIELDS.forEach((key) => {
    dataContainer.set(
      'ClinicData',
      key,
    )(parseList(dataContainer.get('ClinicData', key)));
  });
  return dataContainer;
};
